import formatPriceWithSymbol from './formatPriceWithSymbol';

/**
 * @param {ParentNode} [root=document] - scope to search within.
 */
const formatFreeShippingThresholds = (root = document) => {
  root.querySelectorAll('[data-free-shipping-threshold]').forEach((el) => {
    const amount = parseFloat(el.dataset.amount);

    if (!Number.isFinite(amount)) {
      return;
    }

    try {
      el.textContent = formatPriceWithSymbol(amount);
    } catch (error) {
      el.textContent = String(amount);
    }
  });
};

export default formatFreeShippingThresholds;
